import { DATA_UPDATED_FILL_COLOR, DATA_UPDATED_FONT_COLOR } from "../../../globalValues";

interface UpdateQuoteFeedCellFormatArgs {
  table: Excel.Table;
  relativeColumn: number;
  relativeRow: number;
  context: Excel.RequestContext;
}

export const updateQuoteFeedCellFormat = async ({
  table,
  relativeColumn,
  relativeRow,
  context,
}: UpdateQuoteFeedCellFormatArgs) => {
  const quoteFeedCell = table.columns
    .getItemAt(relativeColumn)
    .getRange()
    .getCell(relativeRow - 1, 0);

  await context.sync();

  quoteFeedCell.format.fill.color = DATA_UPDATED_FILL_COLOR;
  quoteFeedCell.format.font.color = DATA_UPDATED_FONT_COLOR;
};
